import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyPassengerResponse } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

interface DeleteMyFidelityCardParams {
  cardId: string
  passengerId: string
}

export const useDeleteMyFidelityCardMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ cardId, passengerId }: DeleteMyFidelityCardParams) => {
      await apiClient.client.delete(`/me/passengers/${passengerId}/fidelity-cards/${cardId}`)
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.passengers })
    },
    onMutate: async ({ cardId, passengerId }) => {
      await queryClient.cancelQueries({ queryKey: meKeys.passengers })

      const previousPassengers = queryClient.getQueryData<GetMyPassengerResponse[]>(
        meKeys.passengers
      )

      if (previousPassengers) {
        queryClient.setQueryData<GetMyPassengerResponse[]>(
          meKeys.passengers,
          previousPassengers.map((p) =>
            p.id === passengerId
              ? {
                  ...p,
                  fidelityCards: p.fidelityCards.filter((fc) => fc.id !== cardId),
                }
              : p
          )
        )
      }

      return { previousPassengers }
    },
  })
}
